import { ChevronDown } from "lucide-react";

import { sanitizeRichHtml } from "../../shared/safeHtml";

const quoteMarkers = [
  /^\s*>/m,
  /^\s*On [\s\S]{0,500}?wrote:\s*$/im,
  /^\s*Vào [\s\S]{0,500}?đã viết:\s*$/im,
  /^\s*-{2,}\s*(?:Original Message|Forwarded message)\s*-{2,}\s*$/im,
  /^\s*From:\s.+$/im,
];

export function splitQuotedMessage(body: string): { current: string; quoted?: string } {
  const normalized = body.replace(/\r\n/g, "\n");
  let quoteStart = -1;
  for (const marker of quoteMarkers) {
    const match = marker.exec(normalized);
    if (match && (quoteStart < 0 || match.index < quoteStart)) quoteStart = match.index;
  }
  if (quoteStart < 0) return { current: normalized };
  const current = normalized.slice(0, quoteStart).trimEnd();
  const quoted = normalized.slice(quoteStart).trim();
  if (!quoted) return { current: normalized };
  return { current: current || "Reply quoted below", quoted };
}

export function splitRichMessage(value: string): { currentHtml: string; quotedHtml?: string } {
  const documentNode = new DOMParser().parseFromString(value, "text/html");
  const quoteRoot = documentNode.body.querySelector<HTMLElement>(
    ".gmail_quote, .gmail_extra, blockquote[type='cite'], #divRplyFwdMsg",
  );
  if (!quoteRoot) return { currentHtml: sanitizeRichHtml(documentNode.body.innerHTML) || "" };

  const quotedContainer = documentNode.createElement("div");
  if (quoteRoot.id.toLowerCase() === "divrplyfwdmsg") {
    let node: ChildNode | null = quoteRoot as unknown as ChildNode;
    while (node) {
      const next: ChildNode | null = node.nextSibling;
      quotedContainer.append(node as never);
      node = next;
    }
  } else {
    quotedContainer.append(quoteRoot as never);
  }
  return {
    currentHtml: sanitizeRichHtml(documentNode.body.innerHTML) || "",
    quotedHtml: sanitizeRichHtml(quotedContainer.innerHTML) || undefined,
  };
}

export function MessageBody({ body, html }: { body: string; html?: string }) {
  const parts = splitQuotedMessage(body);
  const rich = html ? splitRichMessage(html) : null;
  const canUseRich = Boolean(rich?.currentHtml || rich?.quotedHtml) && (!parts.quoted || Boolean(rich?.quotedHtml));
  return (
    <div className="message__body">
      {canUseRich && rich?.currentHtml
        ? <div className="message-rich-content rich-text-content" dangerouslySetInnerHTML={{ __html: rich.currentHtml }} />
        : <span>{parts.current}</span>}
      {(rich?.quotedHtml || parts.quoted) && (
        <details className="message-quote">
          <summary><ChevronDown aria-hidden="true" size={14} /> Show quoted message</summary>
          {rich?.quotedHtml
            ? <div className="message-rich-content rich-text-content" dangerouslySetInnerHTML={{ __html: rich.quotedHtml }} />
            : <div>{parts.quoted}</div>}
        </details>
      )}
    </div>
  );
}
